import { ActionTree } from 'vuex'
import { RootState } from '@/store/types'
import { ConstructionConnectionState } from './types';

export const actions: ActionTree<ConstructionConnectionState, RootState> = {
  reset({ commit }) {
    commit('vatInfo/CLEAR')
    commit('contactInfo/CLEAR')
    commit('configurationInfo/CLEAR')
    commit('address/CLEAR')
    commit('RESET')
  }
}
